import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import HomeCheckerApplyButton from '../../../common/components/HomeCheckerApplyButton';

import Feature from './Feature';

import './Features.scss';

const Features = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('home-checker.features.title')}
      className="mb-xl"
    />
    <div className="features">
      <Feature
        title={trans('home-checker.features.first.title')}
        content={trans('home-checker.features.first.content')}
      />

      <Feature
        title={trans('home-checker.features.second.title')}
        content={trans('home-checker.features.second.content')}
      />

      <Feature
        title={trans('home-checker.features.third.title')}
        content={trans('home-checker.features.third.content')}
      />

      <Feature
        title={trans('home-checker.features.fourth.title')}
        content={trans('home-checker.features.fourth.content')}
      />
    </div>

    <p className="features__action">
      <HomeCheckerApplyButton />
    </p>
  </div>
);

export default Features;
